<script setup>
// Display hints and a wordhunt grid, dynamically generated based on word lengths.
import { ref, computed, watch } from 'vue';
const props = defineProps({
  q: Object,
  totalTime: Number,
  timeLeft: Number,
  begin: Boolean,
  type: String,
  maxPoints: Number,
  answer: Boolean,
});

/* Words is an array of objects. Objects look like this:

{
  vertical: bool -- true is vertical, false is horiz
  position: { x: number, y: number} -- Starting position for the word
  word: string -- the word itself
  hint: string -- the clue displayed on the screen to help players solve the word
}

*/
// const gridLength = computed(() => {
//   return props.gridCount;
// });
// const gridHeight = computed(() => {
//   return props.gridCount;
// });

// const wordsWithPositions = computed(() => {
//   // Output array of words. Each entry is an array of objects (letters) with x/y coordinates
//   const words = [];
//   const startingGridPoints = []; // So we can check for duplicate starting points
//   for (let a = 0; a < props.words.length; a += 1) {
//     const word = [];
//     const w = props.words[a];
//     for (let b = 0; b < w.word.length; b += 1) {
//       const gridPoint = {
//         x: !w.vertical ? w.position.x : w.position.x + b,
//         y: w.vertical ? w.position.y : w.position.y + b,
//         letter: w.word[b],
//         display: false,
//         key: a,
//         first: false, // First letter in sequence, so we can show key.
//         intersects: null, // Two clues that start on the same tile. Put the shared key here
//       }
//       if (b === 0) gridPoint.first = true;
//       const startingPoint = `${gridPoint.x} ${gridPoint.y}`;
//       // Deal with two potential clues starting on same square.
//       if (startingGridPoints.length && startingGridPoints.filter(x => x === startingPoint).length) {
//         try {
//           gridPoint.intersects = words.filter(w => `${w[0].x} ${w[0].y}` === startingPoint)[0][0].key;
//         } catch {}
//       } 
//       startingGridPoints.push(startingPoint);
//       word.push(gridPoint);
//     }
//     words.push(word);
//   }
//   return words;
// });

// // const grid = reactive({});
// // const xPos = reactive({});
// // const yPos = reactive({});

const timeLeftStyle = 'rgba(35,49,125,1)';
const timeUsedStyle = 'white';



function timerWidth(x) {
  let timeLeftWidth;
  let timeUsedWidth;
  if (props.timeLeft < 1) {
    timeLeftWidth = '0%';
    timeUsedWidth = '100%';
  } else {
    const percentageUsed = (props.timeLeft / x / 0.5) * 100;
    const percentageLeft = ((props.totalTime - props.timeLeft) / x / 0.5) * 100;
    timeLeftWidth = percentageLeft + '%';
    timeUsedWidth = percentageUsed + '%';
  }
  return timeLeftWidth;
};

const timerStyle = computed(() => {
  let styles = [];
  const timerInc = (props.totalTime / (props.q.data.length + 1));
  const percentages = [];
  for (let a = 0; a < props.q.data.length; a += 1) {
    const timerValue = timerInc * a;
    if (!cardDisplay.value[a] && a > 0) {
      styles.push(`background: linear-gradient(180deg, ${timeUsedStyle} 0%, ${timeUsedStyle} ${timerWidth(timerValue)}, ${timeLeftStyle} ${timerWidth(timerValue)}), ${timeLeftStyle} 100%; box-shadow: none`);
    } else {
      styles.push('');
    }
  }
  return styles;
});

const rules = computed(() => {
  const rules = [];
  console.log(props.type);
  switch (props.type) {
    default: break;
    case ('wordFrag'): {
      //rules.push('<strong>Goal:</strong> Create as many words as possible that include one of the the word fragment.');
      //rules.push('<strong>Get Creative:</strong> names, abbreviations, proper nouns, and slang are OK');
      // rules.push('Words that are 7 letters or longer count for double!');
      // rules.push(`The team with the most words earns <strong>${props.maxPoints > 4 ? props.maxPoints : props.maxPoints * 2} points</strong>. Second highest gets <strong>${props.maxPoints > 4 ? props.maxPoints - 1 : props.maxPoints *2 - 1} points</strong>, etc`);
      if (props.q.rules) {
        props.q.rules.forEach(r => {
          rules.push(r);
        });
      }
      break;
    }
    case ('secretWord'): {
      rules.push('<strong>Goal:</strong> Guess the secret word or phrase, based on the clues provided');
      rules.push('<strong>2 points</strong> per correct answer');
      break;
    }
    case ('categoryCrush'): {
      rules.push(`<strong>Goal:</strong> List as many words as you can that fit into the above categories and <strong>begin with the letter</strong> <strong style="font-size: 5rem">${props.q.randomLetter}</strong>`);
      // rules.push(`The team(s) with the most words earns <strong>${props.maxPoints > 4 ? props.maxPoints : props.maxPoints * 2} points</strong>. Second highest gets <strong>${props.maxPoints > 4 ? props.maxPoints - 1 : props.maxPoints *2 - 1} points</strong>, etc`);
      rules.push('<strong>Get Creative:</strong> names, abbreviations, proper nouns, and slang are OK');
      if (props.q.rules) {
        props.q.rules.forEach(r => {
          rules.push(r);
        });
      }
      break;
    }
    case ('alphabetCrush'): {
      rules.push(`<strong>Goal:</strong> Find a word that begins with <strong>every letter of the alphabet</strong> and also fits the category`);
      rules.push('<strong>Get Creative:</strong> names, abbreviations, proper nouns, and slang are OK');
      // rules.push(`The team(s) with the most words earns <strong>${props.maxPoints > 4 ? props.maxPoints : props.maxPoints * 2} points</strong>. Second highest gets <strong>${props.maxPoints > 4 ? props.maxPoints - 1 : props.maxPoints *2 - 1} points</strong>, etc`);
      // rules.push('Any team(s) that complete the whole alphabet get(s) a <strong>bonus 2 points</strong>');
      if (props.q.rules) {
        props.q.rules.forEach(r => {
          rules.push(r);
        });
      }
      break;
    }
    case ('wordCards'): {
    }
    case ('synonymScramble'): {
      rules.push(`<strong>Goal:</strong> Write down as many synonyms (words that mean the same thing) as you can for each of the words above`);
      rules.push('<strong>Get Creative:</strong> Abbreviations, proper nouns, and slang are OK');
      // rules.push(`The team(s) with the most words earns <strong>${props.maxPoints > 4 ? props.maxPoints : props.maxPoints * 2} points</strong>. Second highest gets <strong>${props.maxPoints > 4 ? props.maxPoints - 1 : props.maxPoints *2 - 1} points</strong>, etc`);
      // rules.push('Any team(s) that complete the whole alphabet get(s) a <strong>bonus 2 points</strong>');
      if (props.q.rules) {
        props.q.rules.forEach(r => {
          rules.push(r);
        });
      }
      break;
    }
  }
  return rules;
});

const cardDisplay = ref({});
const cardAnimate = ref({});
const randomizedPool = ref(null);
const interval = ref(null);

function randomPool() {
  return Math.floor(Math.random() * props.q.pool.length);
};

const displayCards = computed(() => {
  const cards = [ ...props.q.data ];
  const displayed = [];
  for (let a = 0; a < cards.length; a += 1) {
    if (cardAnimate.value && cardAnimate.value[a] === true) {
      displayed.push(randomizedPool.value);
    }
    else if (cardDisplay.value[a] === true) {
      displayed.push(cards[a]);
    }
    else {
      displayed.push(false);
    }
  }
  return displayed;
});

const animationStarted = ref(false);

watch(() => props, (newVal) => {
    if (newVal.begin && !animationStarted.value) {
      animationStarted.value = true;
      let timer = 0;
      const defaultInterval = setInterval(() => randomizedPool.value = randomPool(), 100);
      const timerInc = (props.totalTime / (props.q.data.length + 1)) * 100;
      const animationDuration = 2200;
      // Account for slowing down animation
      const timerOffset = ((props.totalTime / (props.q.data.length)) * 1000) - 2000;
      for (let x = 0; x < props.q.data.length; x += 1) {
        interval.value = defaultInterval;
        setTimeout(() => {
          cardAnimate.value[x] = true;
          if (!cardAnimate.value[x]) cardAnimate.value[x] = true;
          if (cardAnimate.value[x - 1]) cardAnimate.value[x - 1] = false;
          cardDisplay.value[x] = true;
          if (x === props.q.data.length - 1) {
            // Stop randomizing after the last one
            setTimeout(() => {
              cardAnimate.value = null;
              clearInterval(interval.value);
            }, timerInc);
          }
        }, timer);
        setTimeout(() => {
          if (cardAnimate.value && cardAnimate.value[x]) cardAnimate.value[x] = false;
        }, timer + animationDuration);
        // setTimeout(() => {
        //   clearInterval(interval.value);
        //   interval.value = setInterval(() => randomizedPool.value = randomPool(), 200);
        // }, timer + timerOffset);
        // setTimeout(() => {
        //   clearInterval(interval.value);
        //   interval.value = setInterval(() => randomizedPool.value = randomPool(), 400);
        // }, timer + (timerOffset * 2));
        timer += timerInc;
      }
    }
    if (newVal.answer) {
      for (let x = 0; x < props.q.data.length; x += 1) {
        cardDisplay.value[x] = true;
        clearInterval(interval.value);
      }
    }
  }, {deep: true}
);

</script>

<template>
  <div class="wordhunt__container">
    <!-- Display the puzzle -->
    <div
        class="wordhunt__td">
      <table
          class="wordhunt__puzzle">
        <tbody>
            <tr
            class="wordhunt__row">
            <td
                :key="x"
                v-for="(card, x) in displayCards"
                class="wordhunt__card"
                :style="timerStyle[x]">
              <Transition
                  name="fade-slow">
                <span
                    v-if="props.q.type === 'wordFrag'"
                    id="wordFragDisplay"
                    v-text="props.q.override ? props.q.override[card] : props.q.pool[card]"
                />
                <span
                    v-else-if="props.q.type === 'synonymScramble'"
                    id="synonymScrambleDisplay"
                    v-text="props.q.data[x]"
                />
                <div
                    v-else-if="card && props.q.type === 'secretWord'"
                    id="secretWordDisplay"
                    class="secret-word">
                  <Transition
                      name="fade">
                    <p
                        v-if="props.answer"
                        v-text="props.q.pool[card].secret"
                        class="secret-word__answer"
                    />
                  </Transition>
                  <p
                      v-for="(clue, cluekey) in props.q.pool[card].clues"
                      :key="cluekey"
                      v-text="clue"
                      class="secret-word__clue"
                  />
                </div>
                <div
                    v-else-if="props.q.type === 'wordCards'"
                    id="wordCardDisplay"
                    class="secret-word">
                  <Transition
                      name="fade">
                    <p
                        v-text="props.q.prompt"
                        class="secret-word__answer"
                    />
                  </Transition>
                  <p
                      v-for="(word, wordkey) in props.q.data"
                      :key="wordkey"
                      v-text="word"
                      class="secret-word__word"
                  />
                </div>
                <div
                    v-else-if="card && props.q.type === 'categoryCrush' || props.q.type === 'alphabetCrush'"
                    id="categoryCrushDisplay"
                    class="secret-word">
                  <span
                      v-text="props.q.category ? props.q.category : props.q.pool[card]"
                      class="category-crush"
                  />
                </div>
              </Transition>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Display the sidebar -->
  </div>
  <ul
      class="wordhunt__td">
    <li
        v-for="rule in rules"
        class="wordhunt__hint__container">
      <div
          class="wordhunt__hint">
        <span
            v-html="rule"
        />
      </div>
    </li>
  </ul>
</template>

<style scoped lang="scss">
ul {
  columns: 2;
  -webkit-columns: 2;
  -moz-columns: 2;
}

.secret-word {
  font-size: 0.25em;
  color: darkslategrey;
  &__clue {
    font-size: 0.8em;
    background-color: rgba(darkslategrey, 0.7);
    margin: 10px;
    border-radius: 15px;
    color: white;
    padding: 5px 10px;
  }
  &__answer {
    background-color: rgba(darken(cornflowerblue, 20%), 0.7);
    padding: 10px;
    margin: 10px;
    border-radius: 15px;
    color: gold;
  }
}

.category-crush {
  font-size: 1.5em;
  color: darkslategrey;
  &__clue {
    font-size: 0.8em;
    background-color: rgba(darkslategrey, 0.7);
    margin: 10px;
    border-radius: 15px;
    color: white;
    padding: 5px 10px;
  }
}
.wordhunt {
  &__td {
    margin: auto;
    padding: 5px 15px;
  }
  &__container {
    display: flex;
  }
  &__puzzle {
    border-spacing: 2.5vmax;
    background: linear-gradient(to top, #2c98c7, #34b4eb);
    border: 9px solid gold;
    border-radius: 15px;
  }
  &__card {
    color: darkslategrey;
    border-radius: 10px;
    background: #eae6ed;
	  box-shadow:
      inset -8px -6px 15px #778,
      inset 38px 18px 36px #fffffc,
      12px 8px 18px hsla(0,0%,0%,0.25);
    width: 35vw;
    height: 35vh;
    font-size: 3em;
    transition: all 1s ease;
  }
  &__hint {
    flex: 1;
    &__container {
      background-color: lighten(darkslategrey, 25%);
      list-style-type: none;
      font-size: .65em;
      border-radius: 10px;
      margin: 0.25vh 0.25vw;
      padding: 0.25vh 0.5vw;
    }
  }
}
</style>
